import { addDays } from "date-fns";

import { SYSTEM_ATTRIBUTE_PROPERTY } from "~/core/constants/attributes";

import { useGlobalNewOpportunityModalContext } from "../context";

import AccountSelect from "./FormItems/AccountSelect";
import Amount from "./FormItems/Amount";
import CloseDate from "./FormItems/Date";
import { OpportunityName } from "./FormItems/OpportunityName";
import StageSelect from "./FormItems/StageSelect";
import PipelineSwitching from "./PipelineSwitching";

export const CoreFields = () => {
  const { coreFieldsDivRef } = useGlobalNewOpportunityModalContext();
  return (
    <div className="p-3" ref={coreFieldsDivRef}>
      <PipelineSwitching />
      <OpportunityName />
      {/* <Account /> */}
      <AccountSelect />
      <Amount
        name={SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_DEAL_SIZE}
        label="Amount"
        placeholder="Enter amount"
      />
      <StageSelect />
      <CloseDate
        name={SYSTEM_ATTRIBUTE_PROPERTY.OPPORTUNITY_CLOSE_DATE}
        label="Close date"
        placeholder="Select date"
        defaultValue={addDays(new Date(), 14)}
      />
    </div>
  );
};
